function SearchModalHandler() {
  nifty.body.on('show.bs.modal', '.modal-with-search', event => {
    $(event.currentTarget).appendTo('body');
  });
}

export default {init: SearchModalHandler}
